import { useEffect } from "react";
import { SITE } from "../data/site";

function upsert(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, path = "/", image, schemas = [] }) {
  useEffect(() => {
    const full = title
      ? `${title} | ${SITE.name}`
      : `${SITE.name} — Taxi Service in Jodhpur & Across Rajasthan`;
    const url = `${SITE.url}${path}`;
    document.title = full;
    if (description) upsert("name", "description", description);
    upsert("property", "og:title", full);
    upsert("property", "og:description", description || SITE.tagline);
    upsert("property", "og:url", url);
    if (image) upsert("property", "og:image", image);
    upsert("name", "twitter:title", full);
    upsert("name", "twitter:description", description || SITE.tagline);

    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", url);

    const injected = [];
    schemas.forEach((s) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-page-schema", "1");
      el.textContent = JSON.stringify(s);
      document.head.appendChild(el);
      injected.push(el);
    });
    return () => injected.forEach((el) => el.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, JSON.stringify(schemas)]);
  return null;
}

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE.url}${it.path}`,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceSchema = (name, description, path) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${SITE.url}${path}`,
  provider: { "@id": `${SITE.url}/#business` },
  areaServed: { "@type": "State", name: "Rajasthan" },
});
